import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

export const applicationRelease = process.env.REACT_APP_RELEASE_ID || "local / nepublicată";
export function databaseLabel(value) {
  if (!value) return "BD: se verifică…";
  const states = { current: "migrări la zi", behind: "necesită actualizare", ahead: "mai nouă decât aplicația", unknown: "versiune necunoscută", unavailable: "verificare indisponibilă" };
  return `BD: ${value.current == null ? "?" : `v${value.current}`} / v${value.required ?? "?"} · ${states[value.status] || states.unavailable}`;
}
export default function VersionStatus({ tenant, userId }) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    let active = true;
    setResult(null);
    if (!tenant || !userId) return () => { active = false; };
    const refresh = () => authFetch("/version-status")
      .then(value => { if (active) setResult({ tenant, userId, value }); })
      .catch(() => { if (active) setResult({ tenant, userId, value: { status: "unavailable" } }); });
    refresh();
    window.addEventListener("focus", refresh);
    return () => { active = false; window.removeEventListener("focus", refresh); };
  }, [tenant, userId]);
  const value = result?.tenant === tenant && result?.userId === userId ? result.value : null;
  return <span aria-label="Versiuni aplicație și bază">
    <span className="d-block">Aplicație: {applicationRelease}</span>
    <span className="d-block" title="Versiunea migrărilor firmei selectate; nu indică până când sunt introduse documentele.">{databaseLabel(value)}</span>
    <span className="d-block" title="Alinierea completă a tabelelor, coloanelor și constrângerilor necesită un audit separat.">Structură completă: neverificată</span>
  </span>;
}
